module.exports = __webpack_public_path__ + "static/banner-liquidites-mobile-9ad0a95a118979d449d9e24b9042a952.jpg";